import { AppstoreAddOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import { useContext } from 'react';

import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';
import { TaskCenterContext } from 'app/context/TaskCenterContext/TaskCenterContext';

import { EmptyState } from '../../EmptyState/EmptyState';

import { RenderModal } from './RenderTaskModal/RenderTaskModal';
import './TaskCenter.scss';
import { Tasks } from './Tasks/Tasks';
import type { Task } from './Types';
import { TaskName } from './Types';

const TASK_SOURCE = 'drawer';

export const TaskCenter = () => {
  const {
    isTaskCenterOpen,
    closeTaskCenter,
    missingTasks,
    doneTasks,
    clickOpenTask,
    clearOpenTask,
  } = useContext(TaskCenterContext);

  const { roomsFromPublishedPackages: filteredRooms, publishedPackages } =
    useContext(LegacyHotelContext);

  const renderTask = (task: Task, index: number) => {
    return (
      <Tasks
        key={index}
        taskInfo={task}
        clickButton={() => {
          clickOpenTask(task, TASK_SOURCE);
          task.taskName === TaskName.VirtualCards && clearOpenTask();
        }}
        renderModal={(onCompleteTask) => (
          <RenderModal
            task={task}
            onCompleteTask={onCompleteTask}
            rooms={filteredRooms}
          />
        )}
        source={TASK_SOURCE}
      />
    );
  };

  return (
    <Drawer
      title={
        <div className="taskCenter__header">
          <h1>Task center</h1>
        </div>
      }
      className="taskCenter"
      width={'510px'}
      open={isTaskCenterOpen}
      bodyStyle={{ padding: 0 }}
      onClose={closeTaskCenter}
    >
      <div className="container">
        <div className="taskCenter__body">
          <div className="taskCenter__body_explanation">
            <h1>Welcome to your Task Center</h1>
            <p>
              In this space, you can quickly update missing information in order
              to increase your hotel's visibility and attractiveness.
            </p>
          </div>
          {publishedPackages.length > 0 ? (
            <div className="taskCenter__body_task">
              {missingTasks?.length > 0 && (
                <div className="taskCenter__body_todo">
                  <div className="section_title">
                    <p>To do</p>
                  </div>
                  {missingTasks.map((task, index) => renderTask(task, index))}
                </div>
              )}
              {doneTasks?.length > 0 && (
                <div className="taskCenter__body_done">
                  <div className="section_title">
                    <CheckCircleOutlined className="doneIcon" />
                    <p>Done</p>
                  </div>
                  {doneTasks.map((task, index) => renderTask(task, index))}
                </div>
              )}
            </div>
          ) : (
            <EmptyState
              title="No tasks yet"
              description="You must have at least one active package to see the tasks appear."
              icon={<AppstoreAddOutlined />}
            />
          )}
        </div>
        <div className="taskCenter__footer">
          <Button size="large" type="ghost" onClick={closeTaskCenter}>
            Close
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
